








































import { mapGetters } from 'vuex'

export default {
  props: ['item'],
  computed: {
    ...mapGetters(['isAdmin']),
  },
  methods: {
    parseMessage(msg: string): string {
      const from = msg.indexOf('<body>')
      const to = msg.indexOf('</body>')
      if (from == -1 || to == -1) {
        return msg
      }

      return msg.substring(from, to)
    },

    getTime(time: string): string {
      return time.split(':')[0]
    },

    getClass(success: boolean, pending: boolean): string {
      if (success) {
        return 'success'
      }

      if (pending) {
        return 'warning'
      }

      return 'danger'
    },
  },
}
